import flowsApi from '../../api/flows'
import _ from 'lodash'

export default {
  namespaced: true,

  state: {
    flows: {
      loading: false,
      value: []
    }
  },

  getters: {
    nluFlows (state, getters, rootState) {
      const flows = _.map(state.flows.value, (el) => ({
        id: el.id,
        botId: el.botId,
        label: el.data.label || 'No name',
        version: el.version
      }))

      const deployments = _.chain(rootState.knowledgebase.deployments.activeDeployments.value)
        .reject('triggersRemoved')
        .map((el) => ({
          id: el.flowId,
          version: el.data.flowVersion,
          triggers: el.data.triggers
        }))
        .flatMap(({ triggers, id, version }) => triggers.map(({ params }) => ({
          id,
          version,
          triggerName: params.name,
          params: _.get(params, 'params.params', [])
        })))
        .filter((el) => /^try\//gim.test(el.triggerName))
        .value()

      const groupedFlows = _.map(deployments, (el) => {
        const flow = _.find(flows, ['id', el.id])

        return {
          id: el.id,
          botId: _.get(flow, 'botId'),
          label: _.get(flow, 'label'),
          value: el.triggerName,
          params: el.params,
          latesVersion: el.version !== _.get(flow, 'version'),
          isActivated: true
        }
      })

      return {
        loading: state.flows.loading || rootState.knowledgebase.deployments.activeDeployments.loading,
        value: groupedFlows
      }
    }
  },

  actions: {
    async fetchFlows ({ commit }) {
      try {
        commit('SET_FLOWS', { loading: true })
        const flows = await flowsApi.getFlows({ projection: ['id', 'botId', 'data.label', 'version'] })
        commit('SET_FLOWS', { value: flows })
      } catch (error) {
        console.error('Fetch flows failed: ', error)
      }
    }
  },

  mutations: {
    SET_FLOWS (state, { loading = false, value = [] }) {
      _.set(state, 'flows', { loading, value })
    }
  }
}
